import { getMessaging, getToken, isSupported } from "firebase/messaging";
import app, { firebaseConfig } from "../firebaseConfig";
import { registerFcmToken } from "./NotificationActions";
import { getUserToken } from "./Utils";

const MESSAGING_SW_PATH = "/firebase-messaging-sw.js";
// Matches the scope the Firebase SDK uses for its own worker, so the app's
// cache worker at scope "/" is left untouched.
const MESSAGING_SW_SCOPE = "/firebase-cloud-messaging-push-scope";

const VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

export async function isFcmSupported() {
  try {
    if (!("Notification" in window)) return false;
    if (!("serviceWorker" in navigator)) return false;
    return await isSupported();
  } catch (e) {
    return false;
  }
}

// The worker lives in public/, where CRA does not substitute process.env, so the
// Firebase config is handed over in the query string instead of being hardcoded.
export function registerMessagingServiceWorker() {
  const params = new URLSearchParams();
  Object.entries(firebaseConfig).forEach(([key, value]) => {
    if (value) params.append(key, value);
  });

  return navigator.serviceWorker.register(`${MESSAGING_SW_PATH}?${params}`, {
    scope: MESSAGING_SW_SCOPE,
  });
}

export async function syncFcmToken({ requestPermission = false } = {}) {
  try {
    if (!getUserToken()) return null;

    if (!VAPID_KEY) {
      console.warn("REACT_APP_FCM_VAPID_KEY is not set, skipping FCM registration");
      return null;
    }

    if (!(await isFcmSupported())) return null;

    if (requestPermission) {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") return null;
    } else if (Notification.permission !== "granted") {
      return null;
    }

    const serviceWorkerRegistration = await registerMessagingServiceWorker();
    const fcmToken = await getToken(getMessaging(app), {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (!fcmToken) return null;

    await registerFcmToken(fcmToken);
    return fcmToken;
  } catch (e) {
    console.error("Failed to sync FCM token", e);
    return null;
  }
}
